import * as React from "react"
import * as ReactDOM from "react-dom"
import {createStore, Store, applyMiddleware, Action} from "redux"
import thunkMiddleware from "redux-thunk"

import {CallJs} from "../../lib/types"
import {
	CallJsParams, MembershipReportAxes, MembershipReportData, MembershipReportFilters, MembershipReportOwnProps,
	MembershipReportState,
	runCurrentReport,
	runReport
} from "./report1";
import {withDefault} from "../../lib/utils";
import {reducer as genericReducer, makeReportApp} from "../../lib/report-builder"
import {DisplayModes, standardModes} from "../../lib/report-builder/graph-renderer";
import {flattenReportChartData} from "../../lib/report-builder/chart-data";

// noinspection JSUnusedGlobalSymbols called via call_js in membership3 oldreports page
export const runReports: CallJs<CallJsParams> = (callback, params) => {
	const div = document.createElement("div")
	const content = document.getElementById('content')
	if (content) {
		content.getElementsByTagName('table')[0].style.width = '100%';
	}

	const types = params.types.map(t => ({value: "" + t.serial, label: t.title}))
	const axes: MembershipReportAxes = {types}
	const reducer: (s: MembershipReportState, a: Action) => MembershipReportState = genericReducer

	const isHidden = false

	const filters: MembershipReportFilters = {
		"date range": {type: "date range", isHidden},
		"timeframe": {
			type: "select box", isHidden,
			selectedDefault: "auto",
			options: {
				auto: "Auto",
				day:"Day",
				month: "Month",
				year: "Year"
			}
		},
		status: {
			type: "checkbox", isHidden,
			label: "Status",
			group: params.statuses.map(t => ({value: "" + t.serial, label: t.title}))
		},
		"states": {
			type: "checkbox", isHidden,
			label: "States",
			group: params.states.map(t => ({value: "" + t.serial, label: t.state}))
		},
		types: {
			type: "checkbox", isHidden,
			label: "Membership Types",
			group: types
		},
	}
	const keys = [
		{id: 'Date', label: 'Date'},
		{id: 'Period', label: 'Period'}
	]
	const displayModes = ["Graph", "Table"]
	const reportTypes: MembershipReportData = {
		numtypes: {
			axis: "types",
			filters: ["date range", "timeframe", "status"],
			label: "Number of memberships by Type",
			renderAs: "bar",
			removeEmptyAxes: true,
			keys: keys,
			defaultDisplayMode: "Graph",
			displayModes: displayModes
		},
		current: {
			axis: "types",
			filters: ["status"],
			label: "Current memberships by Type",
			renderAs: "pie",
			removeEmptyAxes: true,
			keys: keys,
			defaultDisplayMode: "Graph",
			displayModes: displayModes
		},
		statetype: {
			axis: "types",
			filters: ["date range", "timeframe", "status", "states", "types"],
			label: "Memberships by state or Type",
			renderAs: "line",
			removeEmptyAxes: true,
			keys: keys,
			defaultDisplayMode: "Graph",
			displayModes: displayModes
		}
	}
	const ownProps = (store: Store<MembershipReportState>, ajaxPageUrl: string): MembershipReportOwnProps => ({
		title: "Membership Reports",
		store,
		modes: standardModes,
		reportTypes: reportTypes,
		filters,
		axes,
		runReport: (dispatchWrapped) => async (dispatchUnwrapped, getState) => {
			const state = getState();
			try {
				if (state.reportType == "current") {
					const a = await runCurrentReport(state.filters.status, ajaxPageUrl)
					dispatchWrapped({
						type: "set new report data",
						data: {data: a, renderAs: 'pie', axis: reportTypes.current.axis}
					})
				} else {
					const renderAs = reportTypes[state.reportType].renderAs
					// A bug could occur here if the reportType is not "current" but
					// renderAs is "pie". Our app would be in a state where the reportType and
					// filters have changed, but the report data will not have been updated
					// to reflect this
					if (renderAs !== "pie") {
						const dateRange = state.filters['date range']
						const timeframe = state.filters.timeframe
						const a = await runReport(
							state.filters.status,
							state.filters.states,
							state.filters.types,
							state.reportType,
							dateRange.type == "date range" ? dateRange.fromDate : new Date(),
							dateRange.type == "date range" ? dateRange.toDate : new Date(),
							timeframe.type == "select box" ? timeframe.selected : "auto",
							ajaxPageUrl
						)
						dispatchWrapped({
							type: "set new report data",
							data: {data: flattenReportChartData(a.data), renderAs: renderAs, axis: reportTypes[state.reportType].axis}
						})
					}
				}
			} catch (e) {
				window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page")
			}
		}
	})

	const initialState: MembershipReportState = {
		displayMode: "Graph",
		reportType: "numtypes",
		filters: {
			"date range": {type: "date range", fromDate: new Date(), toDate: new Date()},
			"timeframe": {type: "select box", selected: "auto"},
			"states": {type: "checkbox", checked: []},
			types: {type: "checkbox", checked: []},
			"status": {type: "checkbox", checked: []}
		}
	}

	callback(div)
	const store = createStore(withDefault(reducer, initialState), initialState, applyMiddleware(thunkMiddleware))
	const ReportApp = makeReportApp<MembershipReportAxes, MembershipReportFilters, DisplayModes, MembershipReportData, MembershipReportState>()

	ReactDOM.render(<ReportApp {...ownProps(store, params.ajaxPageUrl)} />, div)
}



// WEBPACK FOOTER //
// ./src/membership3/membership-reports/report.tsx